module.exports = __webpack_public_path__ + "img/application_icon_base01@2x.e113d253.png";